__webpack_require__.p = "/interactive/intel/neuroscience-ai-and-gaming/";